import { File, FolderCog, Sofa, WandSparkles } from "lucide-react";

import { SmartlistType } from "../../../api/MediaAPI.types";

import type { LucideIcon } from "lucide-react";

export const SMARTLIST_TYPE_ICONS = {
  [SmartlistType.STANDARD]: FolderCog,
  [SmartlistType.AUTO]: WandSparkles,
  [SmartlistType.SERIES]: Sofa,
} as const satisfies Partial<Record<SmartlistType, LucideIcon>>;

const ICONS_BY_TYPE: Partial<Record<SmartlistType, LucideIcon>> =
  SMARTLIST_TYPE_ICONS;

export function getSmartlistTypeIcon(type: SmartlistType): LucideIcon {
  return ICONS_BY_TYPE[type] ?? File;
}
